export default __webpack_public_path__ + "static/media/Historica.f018b082.png";